import React from 'react';

import Icon from './Icon';

const ErrorIcon = (props) => {
    return (
        <Icon width='32' height='32' {...props}>
            <g fill='none' fillRule='evenodd'>
                <circle fill='#C73636' transform='rotate(90 16 16)' cx='16' cy='16' r='16' />
                <g transform='rotate(180 8.667 14)' fill='#FFF'>
                    <ellipse cx='1.75' cy='1.803' rx='1.75' ry='1.803' />
                    <rect x='.25' y='5.667' width='3' height='17' rx='1' />
                </g>
            </g>
        </Icon>
    );
};

export default ErrorIcon;
